/**
 * @file: useAutoMarkRead.ts
 *
 * Manual-read feed threads (maintenance plans, leads) keep every reminder
 * unread until the user acts on it — but "acted on it" is not only the
 * 标记为已读 button. Converting a reminder into a lead handles it just as
 * well, and that can happen far from this card: the plans timeline, the lead
 * center, another device, or the backend's auto-lead job. Without this, such
 * a message renders its 查看商机 button next to a 标记为已读 one forever.
 *
 * So each body declares when its own subject counts as handled, and the
 * message clears itself the first time that's true. The write is optimistic +
 * idempotent upstream (`useFeedThreadMessages.markRead` no-ops once the row
 * is read), so a body may re-render freely — one write per unread message.
 */

import { useEffect } from 'react';

export const useAutoMarkRead = ({
  handled,
  messageId,
  readAt,
  onMarkRead,
}: {
  /** The body's own "the user already dealt with this" predicate. */
  handled: boolean;
  /** Recipient-row id of this feed message. */
  messageId?: string;
  /** Read timestamp — absent/null means unread. */
  readAt?: string | null;
  onMarkRead?: (recipientId: string) => void;
}) => {
  useEffect(() => {
    if (!handled || !messageId || readAt || !onMarkRead) return;
    onMarkRead(messageId);
  }, [handled, messageId, readAt, onMarkRead]);
};
